panelStaffUpdateHandler = {
    $suTitleContainer = jQuery('.su-title-container').find('.title-item'),
    $titleItem = jQuery('.title-item'),
    $contentItem = jQuery('.content-item'),
    $html = jQuery('html'),

    setSelectedItem: function($obj){
        id = $obj.getAttribute('data-su-title-id');
        $selectedContent = jQuery('[data-su-content-id='+id+']');
        
        $suTitleContainer.removeClass('active');
        $contentItem.removeClass('active');
        
        $selectedContent.addClass('active');
        jQuery($obj).addClass('active');

        $html.animate({
            scrollTop: 0
        }, 1000);
        
    },

    initialize: function(){
        var self = this;        
		jQuery("body").on('click', '.title-item', function(){
            self.setSelectedItem(this);
        })
    }
}

panelContactHandler = {
    $titleItem = jQuery('.cell-contact'),
    $map = jQuery('.map'),
    $mapsContainer = jQuery('.maps-container'),

    setSelectedItem: function($obj){
        $map.hide();
        id = $obj.getAttribute('data-item');
        $selectedMap = jQuery('[data-item-target='+id+']');
        
        $titleItem.removeClass('active');
        
        $selectedMap.fadeIn();
        jQuery($obj).addClass('active');        
    },

    initMap: function() {
        $mapsContainer.children().each(function(){
            var maps_id = this.id;
            var latlng = this.getAttribute('data-coordinate').split(',');
            var lat = latlng[0];
            var lng = latlng[1];
            var myLatLng = new google.maps.LatLng(lat, lng)
            
            if ((lat != '') && (lng != '')) {
                var args = {
                    zoom: 16,
                    center: myLatLng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    mapTypeControl: false,
                    streetViewControl: false,
                    disableDefaultUI: true,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.RIGHT_CENTER
                    },
                };
                var mapContainer = document.getElementById(maps_id);
                if (mapContainer) {
                    map = new google.maps.Map(document.getElementById(maps_id), args);
                    new google.maps.Marker({
                        position: myLatLng,
                        map
                    });
                }
            }
        })
    },

    initialize: function(){

        var self = this;
        this.initMap();
        
		jQuery("body").on('click', '.cell-contact', function(){
            self.setSelectedItem(this);
        })
    }
}


var panelCalendarHandler = {
    $navNext = jQuery('.nav-next-month'),
    $navPrev = jQuery('.nav-prev-month'),
    $monthName = jQuery('.nav-month-name'),
    $monthNameText = jQuery('.month-name-text'),
    $buttonPrev = jQuery('.simcal-prev'),
    $buttonNext = jQuery('.simcal-next'),
    $currentMonth = jQuery('.simcal-current-month'),

    setMonthName: function() {
        self.$monthNameText.html($($currentMonth[0]).text());
    },

    initialize: function(){
        
        var self = this;
        // self.setMonthName(true);
        
        // $navNext.on("click", function(){
        //     self.$buttonNext.trigger("click");
        // });

        // $navPrev.on("click", function(){
        //     self.$buttonPrev.trigger("click");
        // });

        // setInterval(function() {
        //     self.setMonthName();
        // }, 250);
        
    }
}

var panelMyProfileHandler = {
    $panelMyProfile = jQuery('.panel-my-profile'),
    $fileProfilePict = jQuery('#file-profile-pict'),
    $fileThumbnailPict = jQuery('#file-thumbnail-pict'),
    imgProfile = null,
    dataTemp = {},
    dataChanged = {},

    getData: function(){
        var self = this;
        var data = {};
        self.$panelMyProfile.find(".input-type-text").each(function(){
            var name = $(this).attr('name');
            var val  = $(this).val();
            data[name] = val;
        })
        self.$panelMyProfile.find(".input-type-select").each(function(){
            var name = $(this).attr('name');
            var val  = $(this).find(":selected").val();
            data[name] = val;
        })
        data['profile']   = self.$panelMyProfile.find('.profile-pict').attr('src');
        data['thumbnail'] = self.$panelMyProfile.find('.cover-image-container').attr('data-img');

        return data;
    },

    revertData: function(){
        var self = this;
        self.$panelMyProfile.find(".input-type-text").each(function(){
            var name = $(this).attr('name');
            $(this).attr('value', self.dataTemp[name]);
            $(this).val(self.dataTemp[name]);
        });
        self.$panelMyProfile.find(".input-type-select").each(function(){
            var name = $(this).attr('name');
            $(this).val(self.dataTemp[name]).change();
        })
        
        self.$panelMyProfile.find('img.profile-pict').attr('src', self.dataTemp['profile']);
        self.$panelMyProfile.find('.cover-image-container').css({
            'background-image': 'url('+self.dataTemp['thumbnail']+')'
        });
        self.$fileProfilePict.val('');
        self.$fileThumbnailPict.val('');
    },
    
    initialize: function(){
        var self = this;
        var $form = self.$panelMyProfile.find('.form-container');
        var $panelEmployeeHighlight = self.$panelMyProfile.find('.panel-employee-highlight');
        
        this.$panelMyProfile.find('.btn-edit').on('click', function(e){
            e.preventDefault();
            $form.addClass('edit-mode');
            $panelEmployeeHighlight.addClass('edit-mode');
            self.dataTemp = self.getData();
        });

        this.$panelMyProfile.find('.btn-cancel').on('click', function(e){
            e.preventDefault();
            $form.removeClass('edit-mode');
            $panelEmployeeHighlight.removeClass('edit-mode');
            self.revertData();
        })

        this.$fileProfilePict.on('change', function(){
            var files = this.files[0];
            var reader = new FileReader();
            reader.onload = function (e) {
                self.$panelMyProfile.find('img.profile-pict').attr('src', e.target.result);
            }

            if (files) {
                reader.readAsDataURL( files );	
            }
        })

        this.$fileThumbnailPict.on('change', function(){
            var files = this.files[0];
            var reader = new FileReader();
            reader.onload = function (e) {
                self.$panelMyProfile.find('.cover-image-container').css({
                    'background-image': 'url('+e.target.result+')'
                });
            }

            if (files) {
                reader.readAsDataURL( files );	
            }
        })
    }
}

jQuery(document).ready(function($) {

    panelStaffUpdateHandler.initialize();
    panelContactHandler.initialize();
    panelCalendarHandler.initialize();
    panelMyProfileHandler.initialize();

})
